const { ccclass, property } = cc._decorator;
import ViewBase from "../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../framework/tools/scrollview/listview";
import ClubInfoItem from "./clubInfoItem";
import { fork } from "child_process";

@ccclass
export default abstract class ClubListView extends ViewBase {

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(cc.Label)
    clubIndex:cc.Label[] = []

    @property(cc.Node)
    leftBtn:cc.Node = null

    @property(cc.Node)
    rightNode:cc.Node = null

    @property(cc.Node)
    joinClubPanel:cc.Node = null

    @property(cc.ScrollView)
    pageView:cc.ScrollView = null

    oldPos = cc.Vec2.ZERO
    itemList = []
    moveProp = 0 

    onLoad() {
        this.oldPos = this.joinClubPanel.getPosition()
    }

    curProp = 0
    moveButton(move: string) {
        
        // if (move == "left") {
        //     this.curProp -= this.moveProp
        // } else if (move == "right") {
        //     this.curProp += this.moveProp
        // }
        // this.pageView.scrollToPercentHorizontal(this.curProp)
    }


    updateShow(m_Data:any = null, lastId){
        if (m_Data == null){ 
            m_Data = []
        }
        let tempData = []
        // this.moveProp =  (1/Math.ceil(m_Data.length/2))
        // this.curProp = this.moveProp
        for (let index = 0; index < m_Data.length; index++) {
            const data = m_Data[index];
            if (data.userClubId == lastId){
                tempData.unshift(data)
            }
            else{
                tempData.push(data)
            }
        }
        for (let index = 0; index < tempData.length; index++) {
            const data = tempData[index];
            if (this.itemList[index] == null){
                let o = cc.instantiate(this.prefab)
                this.content.addChild(o)
                this.itemList[index] = o.getComponent(ClubInfoItem)
            }
            this.itemList[index].setData(data, index)
            //this.itemList[index].node.active = true
        }

        if (this.itemList.length > tempData.length){
            for (let index = tempData.length; index < this.itemList.length; index++) {
                this.itemList[index].node.active = false                
            }
        }
        this.leftBtn.active = tempData.length > 2
        this.rightNode.active = tempData.length > 2
        this.joinClubPanel.position = tempData.length <= 0 ? new cc.Vec2(0, this.oldPos.y) : this.oldPos

        this.joinClubPanel.opacity = 0
        this.joinClubPanel.runAction(cc.fadeIn(0.3))
    }


    updateShowInPut(inStr){
        for (let index = 0; index < 4; index++) {
            if (this.clubIndex[index] != null){
                this.clubIndex[index].string = inStr[index] == null ? "" : inStr[index]; 
            }
        }
    }

   
}